import { render, staticRenderFns } from "./create-message.vue?vue&type=template&id=cfeeda42&scoped=true&"
import script from "./create-message.vue?vue&type=script&lang=js&"
export * from "./create-message.vue?vue&type=script&lang=js&"
import style0 from "./create-message.vue?vue&type=style&index=0&id=cfeeda42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfeeda42",
  null
  
)

export default component.exports